import React from 'react';
import {
    RadioGroup,
    RadioGroupProps as BaseRadioGroupProps,
    RadioGroupItemProps as BaseRadioGroupItemProps,
} from '@economic/taco';

import Field, { FieldProps } from '../Field';

interface RadioGroupOption extends Omit<BaseRadioGroupItemProps, 'children'> {
    text: BaseRadioGroupItemProps['children'];
}

interface RadioGroupProps extends FieldProps<BaseRadioGroupProps> {
    options: RadioGroupOption[];
}

const parseNumber = value => Number(value);

const FieldRadioGroup = ({ child: Component, options, ...fieldProps }: RadioGroupProps) => {
    const radiogroupItems = options.map(({ text, ...itemProps }, index) => (
        <RadioGroup.Item key={index} {...itemProps}>
            {text}
        </RadioGroup.Item>
    ));
    return <Component {...fieldProps}>{radiogroupItems}</Component>;
};

export function RadioGroupField({ as, ...props }: RadioGroupProps) {
    const Component = as || RadioGroup;
    return <Field {...props} as={FieldRadioGroup} child={Component} wrapWithLabel={false} />;
}

export function NumberRadioGroupField(props: RadioGroupProps) {
    return <RadioGroupField {...props} parse={parseNumber} />;
}
